import { FeatureLogger } from '../../utils/feature-logger';

const name = 'broadstreet';

export const logger = new FeatureLogger(name);
